import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../atoms/Text';
import { VariantType } from '../../atoms/Text/Text';
import styles from './index.pcss';

interface IProductLabelProps {
  title: string;
  description: string;
  isGift?:boolean;
  volume?: string | undefined;
  purity?: string | undefined;
  withNoWrap?: boolean;
  textVariants?: VariantType[];
  luxe?: boolean | undefined;
  pageType?: string | undefined;
  reduceLineHeight?: boolean | undefined;
  wrapProductDesc?: boolean;
  isMembershipArticle?: boolean;
  duration?: string;
  ariaHidden?:boolean
}

const cx = classNames.bind(styles);

const ProductLabel: React.FC<IProductLabelProps> = ({
  title,
  description,
  isGift=false,
  volume,
  purity,
  withNoWrap,
  textVariants,
  luxe,
  pageType = '',
  reduceLineHeight = false,
  wrapProductDesc,
  isMembershipArticle = false,
  duration = '',
  ariaHidden=false
}: IProductLabelProps) => {
  const containerCls: string = cx('container');
  const luxeDescription = luxe && pageType ? `${pageType}-product-description` : '';
  const descriptionCls: string = cx(luxeDescription, {
    'with-no-wrap': withNoWrap,
    'wrap-product-details': wrapProductDesc
  });

  const luxePdp = pageType === 'pdp' && luxe;
  const luxeRetryPayment = pageType === 'retryPayment' && luxe;

  return (
    <div className={containerCls} aria-hidden={ariaHidden}>
      <div className={cx('prod-desc', { 'wrap-product-details': wrapProductDesc })}>
       {!isMembershipArticle && <Text
          id={cx(luxe && pageType !== 'pdp' ? `${pageType}_product_title` : 'product_title')}
          variant={luxePdp ? 'T4' : textVariants[0]}
          color={pageType === 'order-details' ? 'Nero' : luxe ? 'Light_Black' : 'Dark_Grey'}
          weight="bold"
          textTransform={luxePdp || luxeRetryPayment ? 'is-uppercase' : 'none'}
          role='heading'
          ariaLevel={3}
        >
          {title}
        </Text>}
        <div className={descriptionCls} style={pageType==='cart'?{display:'flex'}:{}}>
          <Text
            id="product_desc"
            variant={luxePdp ? 'T3' : textVariants[1]}
            color={pageType === 'order-details' ? 'Nero' : luxe ? 'Light_Black' : 'Dark_Grey'}
            weight="regular"
            customClass={cx({ 'custom-line-height': reduceLineHeight })}
            {...(isGift ? {
              ariaLabel: `${description.length > 36 ? description.substring(0, 29) + '...' :  description} ${purity ? ` | ${purity}` : ''} ${volume ? ` | ${volume}` : ''} - Free Gift`
            } : {})}
          >
            {description.length > 36 ? description.substring(0, 29) + '...' :  description}
            {purity ? ` | ${purity}` : ''}
            {volume ? ` | ${volume}` : ''}
          </Text>
        </div>
        {isMembershipArticle && (
          <Text weight="regular" variant="T1" color="Dark_Grey">
            {duration}
          </Text>
        )}
      </div>
    </div>
  );
};

ProductLabel.defaultProps = {
  withNoWrap: false,
  volume: '',
  purity: '',
  textVariants: ['T2', 'T2']
};

export default ProductLabel;
